var styles = {
  "ColorPicker": "_ColorPicker_q6sds_34",
  "TopContainer": "_TopContainer_q6sds_38",
  "MiddleContainer": "_MiddleContainer_q6sds_42"
};

export { styles as default };
